import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { SubscriptionBasedComponent } from 'src/app/subscription-helpers/subscription-based.component';
import { RequestService } from 'src/app/services/request.service';
import Employee from 'src/app/model/product/employee';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from '@angular/forms';
import BrowserHelper from '../../../../helpers/browser-helper';
import { SubProject } from '../../../../model/project/sub-project';

@Component({
  selector: 'site-visit',
  templateUrl: './site-visit.component.html',
  styleUrls: ['./site-visit.component.scss'],
})
export class SiteVisitComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @Input()
  public inputProject: SubProject;
  @Output()
  public outputProject = new EventEmitter();

  public employeeChoices: Employee[] = [];
  employeeFormGroup: UntypedFormGroup;
  public isCollapsed = true;
  public safari: boolean;

  constructor(
    private requestService: RequestService,
    private formBuilder: UntypedFormBuilder
  ) {
    super();
  }

  getEmployees() {
    this.addSubscription(this.requestService.get('employees'), (result) => {
      this.employeeChoices = <Employee[]>result.body;
    });
  }

  ngOnInit() {
    this.safari = BrowserHelper.isSafari();
    this.isCollapsed = !!this.inputProject.id;
    this.employeeFormGroup = this.initEmployeeForm();
    this.getEmployees();
  }

  initEmployeeForm() {
    return this.formBuilder.group({
      employee: new UntypedFormControl(''),
    });
  }

  siteVisitChanged(value) {
    this.inputProject.projectPlacement.siteVisit = value;
    this.outputProject.emit();
  }

  siteVisitExecutedChanged(value) {
    this.inputProject.projectPlacement.siteVisitExecuted = value;
    this.outputProject.emit();
  }

  extraInfoSiteVisitChanged(value) {
    this.inputProject.projectPlacement.extraInfoSiteVisit = value;
    this.outputProject.emit();
  }

  deadlineSiteVisitChanged(value) {
    this.inputProject.projectPlacement.deadlineSiteVisit = value;
    this.outputProject.emit();
  }

  chargeChanged(value) {
    this.inputProject.projectPlacement.charge = value;
    this.outputProject.emit();
  }

  compareEntities(o1, o2) {
    if (o1 == null && o2 == null) {
      return true;
    } else if (o1 != null && o2 != null) {
      if (o1.id === o2.id) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  employeeChange(value) {
    this.outputProject.emit();
  }
}
